var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-hint__wrapper"},[(_vm.activePuzzleRow)?_c('div',{staticClass:"c-hint"},[_c('div',{staticClass:"c-hint__letter"},[_vm._v("\n            "+_vm._s(_vm._f("numberToLetter")(_vm.activeRowIndex))+"\n        ")]),_vm._v("\n\n        "+_vm._s(_vm._f("capitalize")(_vm.activePuzzleRow.hint))+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }